import ReportsScreen from '@screens/Reports/ReportsScreen';

export default ReportsScreen;
